import React from 'react'
import { Input, Label, Switch as SwitchInput } from './switch.style'

type Props = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export const Switch = (props: Props) => {
  return (
    <Label>
      <Input type="checkbox" {...props} />
      <SwitchInput />
    </Label>
  )
}
